import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

import { getXCLEARCorrelationInfo } from '@api/utils'
import { session } from './session'
import { createLookupPipe, LookupPipe } from './createLookupPipe'
import { detectFlow } from './utils'
import { useFlag } from '@hooks/useFlag'

export function useLookupPipe(): LookupPipe {
  const router = useRouter()
  const flag = useFlag('updateLookupUx') ?? { enabled: undefined }
  const pipeRef = useRef<LookupPipe | undefined>(undefined)
  const routeRef = useRef<string>('')
  const route = router.route

  if (!pipeRef.current || routeRef.current !== route) {
    routeRef.current = route

    pipeRef.current = createLookupPipe({
      xCLEARCorrelationInfo: getXCLEARCorrelationInfo(),
      lookupFlowSessionId: session.lookupFlowSessionId,
      flow: detectFlow(route),
      searchType: '',
      route,
      flagEnabled: String(flag.enabled ?? 'pending'),
    })
  }

  useEffect(() => {
    return () => {
      pipeRef.current = undefined
    }
  }, [])

  return pipeRef.current
}
